import { createSelector } from 'reselect'
import { CommonState } from '~/store/types'

const selectAccountStatementState = (state: CommonState) => state.straitsXAccountStatement

export const selectIsAccountStatementUIEnabled = createSelector(
  [selectAccountStatementState],
  (state) => state.isAccountStatementUIEnabled
)
